module.exports = __webpack_public_path__ + "assets/details-other-region.c300867c.svg";